import { create } from "zustand";

export const useBcmAppDetailsStore = create((set) => ({
    documents: [],
    contacts: [],
    loading: false,
    error: null,

    setDocuments: (documents) => set({ documents }),
    setContacts: (contacts) => set({ contacts }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
}));
